export default __webpack_public_path__ + "static/media/uz.809b9ed5.svg";